import type { App } from 'vue'
import { useRealtimeStore } from '@/stores/realtime'
import websocketService from '@/services/websocket.service'

export default {
  install(app: App) {
    // 🌐 WebSocket service global
    app.config.globalProperties.$websocket = websocketService
    app.provide('websocket', websocketService)
    
    // 🔄 Realtime store global
    const realtimeStore = useRealtimeStore()
    app.config.globalProperties.$realtime = realtimeStore
    app.provide('realtime', realtimeStore)
    
    console.log('🔌 Realtime plugin installed')
  }
}
